<template>
    <div class="Achievement">
        <div class="Achievement-dv">
            <div class="Achievement-dvh">
                <!-- <img src="../../assets/bg-xiangqing-lan.png" alt=""> -->
                <div class="xiangqing">

                </div>
                <h1>成绩分析<br/><span>{{name}}</span></h1>
            </div>
        </div>
        <div class="Achievement-dv1" >
            <h3>课程目标达成成绩表</h3>
            <div v-for="(item,i) in listdata1" :key="i">
                <ul>
                    <li>
                        <div class="title_tex" v-if="item.score  && item.goalMark && item.classAvgMark">
                            <!-- <img src="../../assets/dian-biaoti.png" alt=""> -->
                            <div class="biaoti">

                            </div>
                            <span>{{i+1}}、{{item.name}}</span>
                            <div class="radius_da" >
                                <div>
                                    <span>得分</span>
                                    <p>{{item.score}}</p>
                                </div>
                                <div>
                                    <span>达成度</span>
                                    <p>{{item.goalMark}}</p>
                                </div>
                                <div class="radius_span">
                                    <span>班级平均达成度</span>
                                    <p>{{item.classAvgMark}}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <h3 >课程目标达成度分析表</h3>
                <!-- 柱状图引用 -->
            <div >
                <Histogram :pointLists="pointList"></Histogram>
            </div>
        </div>
        <back-to :path="'/AchievingCourses'"></back-to>
    </div>
</template>
<script>
import Histogram from "@/components/echaars/Histogram"
import backTo from '@/components/back'
import api from "@/api"
export default {
    components: { backTo,Histogram },
    data(){
        return{
            name:this.$route.query.name,
            aaa:true,
            showifon:false,
            showradius:false,
            showradius1:true,
            isActive:0,
            listdata1:[],
            pointList:[],
            listdata:[],
            
        }
    },
    methods:{
        jumpshowRadius(i,d,id){
            this.isActive = id
        },
        submit(){
            this.$router.push({path: '/CompleteQuestionnaire'})
        },
        courseGoal(){
            let classId = JSON.parse(localStorage.getItem('userInfo')).classId
            this.$get(api.questionnaire.courseGoal(this.$route.query.courseId,classId)).then(res=>{
                if(res.status == 1){
                    if(res.data.length == 0){
                        this.$toast({
                            message: '暂时没有数据',
                            duration: 1000,
                            position: 'bottom'
                        })
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000);
                    }else{
                        this.listdata =res.data
                        let arr = []
                        this.listdata.forEach(item=>{
                            if(item.score  && item.goalMark && item.classAvgMark){
                                arr.push(item)
                            }
                        })
                        this.listdata1 = arr
                        this.pointList = this.listdata1
                    }
                }
            })
        }
    },
    mounted(){
        this.courseGoal()
        
    }
}
</script>
<style lang="scss" scoped>
    .Achievement{
        .Achievement-dv{
            .Achievement-dvh{
                width: 100%;
                height: 90px;
                .xiangqing{
                    width:100%;
                    height:100PX;
                    margin-right: 15px;
                    background: url('../../assets/bg-xiangqing-lan.png') no-repeat center center;
                    background-size: 100% 100%; 
                }
                h1{
                    position: absolute;
                    left:0; 
                    top: 20px; 
                    width: 100%;
                    text-align: center;
                    font-size:36px;
                    font-family:PingFangSC;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    letter-spacing: 5px;
                    span{
                        margin-top: 15px;
                        font-size:26px;
                        display: block;
                    }
                }
                img{
                    width: 100%;
                    height: 200px;
                }
            }
        }
        .Achievement-dv1{
            width: 100%;
            height: 91.5%;
            position: absolute;
            top: 140px;
            background:rgba(255,255,255,1);
            box-shadow:$box-shadow;
            border-radius:40px 40px 0px 0px;
            h3{
                font-size:30px;
                font-family:PingFangSC;
                font-weight:700;
                color:rgba(50,50,50,1);
                text-align: center;
                margin-top: 39px;
                margin-bottom: 59px;
            }
            ul{
                li{
                    padding-left: 51px;
                    padding-right: 51px;
                    .title_tex{
                        overflow: hidden;
                        img{
                            width: 40px;
                            height: 22px;
                            margin-right: 15px;
                            float: left;
                            margin-top: 13.5px;
                        }
                        .biaoti{
                            margin-top: 10px;
                            float:left;
                            width:45px;
                            height:25px;
                            margin-right: 15px;
                            background: url('../../assets/dian-biaoti.png') no-repeat center center;
                            background-size: 100% 100%; 
                        }
                        
                        span{
                            font-size:24px;
                            font-family:PingFangSC;
                            font-weight:700;
                            color:#323232;
                        }
                    }
                    
                    .radius_da{
                        display: flex;
                         margin-left: 50px;
                        div{
                            flex:1;
                            margin-top: 20px;
                            margin-bottom: 20px;
                            span{
                                font-size:20px;
                                font-family:PingFangSC;
                                font-weight:400;
                                color:rgba(150,150,150,1);
                                display: block;
                                margin-bottom: 20px;
                            }
                            p{
                                text-align: left;
                                margin-left: 0;
                                font-size:20px;
                                font-family:PingFangSC;
                                font-weight:500;
                                color:rgba(50,50,50,1);
                            }
                        }
                        .radius_span{
                            text-align: right;
                            p{
                                text-align: right;
                            }
                        }
                        // div:last-child{
                        //     p{
                        //         text-align: right;
                        //         margin-right: 40px;
                        //     }
                        // }
                    }
                    
                }
            }
        }
        .Achievement-dv3{
            position: fixed;
            bottom: 80px;
            left: 24px;
            img {
                width: 71px;
                height: 71px;
            }
        }
        .Achievement-dv4{
            width:650px;
            height:100px;
            background:linear-gradient(90deg,rgba(142,233,202,1) 0%, rgba(3,177,135,1)100%);
            box-shadow:0px 0px 30px 0px rgba(156,233,200,0.6);
            border-radius:50px;
            margin: 0 auto;
            margin-bottom: 50px;
            text-align: center;
            color: #fff;
            line-height: 100px;
        }
    }
</style>